import _toConsumableArray from "/home/runner/work/commercetools-docs/commercetools-docs/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/commercetools-docs/commercetools-docs/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @typedef {import('mdast').Root|import('mdast').Parent['children'][number]} MdastNode
 * @typedef {import('./index.js').H} H
 * @typedef {import('./index.js').Handler} Handler
 * @typedef {import('./index.js').Content} Content
 */
import { u } from 'unist-builder';
var own = {}.hasOwnProperty;
/**
 * Transform an unknown node.
 * @type {Handler}
 * @param {MdastNode} node
 */

function unknown(h, node) {
  var data = node.data || {};

  if ('value' in node && !(own.call(data, 'hName') || own.call(data, 'hProperties') || own.call(data, 'hChildren'))) {
    return h.augment(node, u('text', node.value));
  }

  return h(node, 'div', all(h, node));
}
/**
 * @type {Handler}
 * @param {MdastNode} node
 */


export function one(h, node, parent) {
  var type = node && node.type;
  /** @type {Handler} */

  var fn; // Fail on non-nodes.

  if (!type) {
    throw new Error('Expected node, got `' + node + '`');
  }

  if (own.call(h.handlers, type)) {
    fn = h.handlers[type];
  } else if (h.passThrough && h.passThrough.includes(type)) {
    fn = returnNode;
  } else {
    fn = h.unknownHandler;
  }

  return (typeof fn === 'function' ? fn : unknown)(h, node, parent);
}
/**
 * @type {Handler}
 * @param {MdastNode} node
 */

function returnNode(h, node) {
  // @ts-expect-error: Pass through custom node.
  return 'children' in node ? _objectSpread(_objectSpread({}, node), {}, {
    children: all(h, node)
  }) : node;
}
/**
 * @param {H} h
 * @param {MdastNode} parent
 */


export function all(h, parent) {
  /** @type {Array<Content>} */
  var values = [];

  if ('children' in parent) {
    var nodes = parent.children;
    var index = -1;

    while (++index < nodes.length) {
      var result = one(h, nodes[index], parent);

      if (result) {
        if (index && nodes[index - 1].type === 'break') {
          if (!Array.isArray(result) && result.type === 'text') {
            result.value = result.value.replace(/^\s+/, '');
          }

          if (!Array.isArray(result) && result.type === 'element') {
            var head = result.children[0];

            if (head && head.type === 'text') {
              head.value = head.value.replace(/^\s+/, '');
            }
          }
        }

        if (Array.isArray(result)) {
          values.push.apply(values, _toConsumableArray(result));
        } else {
          values.push(result);
        }
      }
    }
  }

  return values;
}